/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-01-13 11:16:51
 **/

import styled from "@emotion/styled";

import { _T } from "@rfice/language";

import { useUnityCommand } from "@/frameworks/core/unity";
import { Button, Column, Row, Switch, Tooltip, Typography } from "@/frameworks/designStuff";
import useWhiteboardStore from "@/modules/whiteboard/store/useWhiteboardStore";
import Layout from "../../Layout";

export default function Experimental() {
	const enableFECameraFeed = useWhiteboardStore((state) => state.enableFECameraFeed);
	const setEnableFECameraFeed = useWhiteboardStore((state) => state.setEnableFECameraFeed);
	const unityCommand = useUnityCommand();

	const handleOnChange = () => {
		setEnableFECameraFeed(!enableFECameraFeed);
		unityCommand.useFECameraFeed({ enable: !enableFECameraFeed });
	};

	return (
		<>
			<Layout title="실험실">
				<Contents>
					<Section>
						<Row gap={2}>
							<Typography.p typoSize="Title1">{_T("FE 카메라 피드 사용")}</Typography.p>
							<Tooltip
								message={_T("Unity 카메라 피드 대신 FE 카메라 피드를 사용합니다.")}
								position="top"
								hasIcon={false}
							>
								<Button.Icon name="Help24" size="small_18" filled="transparent" />
							</Tooltip>
						</Row>
						<Switch checked={enableFECameraFeed} onChange={handleOnChange} />
					</Section>
					{/* <Section>
						<Row gap={2}>
							<Typography.p typoSize="Title1">{_T("액티비티 사용")}</Typography.p>
							<Tooltip message={_T("액티비티 실험기능을 사용합니다.")} position="top" hasIcon={false}>
								<Button.Icon name="Help24" size="small_18" filled="transparent" />
							</Tooltip>
						</Row>
						<Switch
							checked={enableActivity}
							onChange={() => setEnabledExperimentalActivity(!enableActivity)}
						/>
					</Section>
					<Section>
						<Row gap={2}>
							<Typography.p typoSize="Title1">{_T("통화 > 아웃바운드 통화 사용")}</Typography.p>
							<Tooltip message={_T("통화 > 아웃바운드 통화 사용")} position="top" hasIcon={false}>
								<Button.Icon name="Help24" size="small_18" filled="transparent" />
							</Tooltip>
						</Row>
						<Switch
							checked={enableOutboundCall}
							onChange={() => setEnableOutboundCall(!enableOutboundCall)}
						/>
					</Section>
					<Section>
						<Row gap={2}>
							<Typography.p typoSize="Title1">{_T("채팅 > 스레드 사용")}</Typography.p>
							<Tooltip message={_T("채팅 > 스레드 사용")} position="top" hasIcon={false}>
								<Button.Icon name="Help24" size="small_18" filled="transparent" />
							</Tooltip>
						</Row>
						<Switch checked={enableChatThread} onChange={() => setEnableChatThread(!enableChatThread)} />
					</Section> */}
				</Contents>
			</Layout>
		</>
	);
}

const Contents = styled(Column)`
	width: 100%;
	padding: 0 8px;
	margin-bottom: 12px;
`;

const Section = styled(Row)`
	padding: 8px 0;
	width: 100%;
	justify-content: space-between;
	align-items: center;
`;
